export const getCurrentStep = (form, fieldId) => {
  var _form$steps;
  const stepCount = form != null && form.steps ? form.steps.length - 1 : 0;
  const hasSteps = stepCount > 0;
  const stepNumber = hasSteps && (form == null || (_form$steps = form.steps) == null ? void 0 : _form$steps.findIndex(step => {
    var _step$layout;
    return (_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null || (_step$layout = _step$layout.items) == null ? void 0 : _step$layout.find(item => item.fieldId === fieldId);
  }));
  const isLastStep = stepNumber === stepCount;
  return {
    hasSteps,
    stepNumber,
    isLastStep
  };
};
//# sourceMappingURL=utils.js.map